import React from "react";
import'./About.css'
import theme_pattern from '../../Assets/theme_pattern.svg'
import profile_img from '../../Assets/profile_img.svg'
const About =() =>{
    return(
        <div id="about" className="about">
            <div className="about-title">
                <h1>About Me</h1>
                <img src={theme_pattern} alt="" />
            </div>
            <div className="about-section">
                <div className="about-left">
                    <img src={profile_img} alt="" />
                </div>
                <div className="about-right">
                    <div className="about-para">
                        <p>
                            I am a passionate Software Engineer and Full Stack Developer, pursuing B.Tech in Artificial Intelligence and Machine Learning at BIT Mesra. My expertise spans building scalable web applications and distributed systems using ReactJS, Next.js, Node.js, and MongoDB.
                        </p>
                        <p>
                            I thrive in competitive programming (450+ LeetCode problems, contest ratings), and love solving algorithmic challenges. My projects have solved real user problems for 900+ people, and my internships emphasize reliable, high-performance systems. I enjoy collaborating, learning fast, and tackling new engineering challenges.
                        </p>
                    </div>
                    <div className="about-skills">
                        <div className="about-skill">
                            <p>HTML & CSS</p><hr style={{width:"50%"}}></hr>
                        </div>
                        <div className="about-skill">
                        <p>ReactJS & NextJs</p><hr style={{width:"70%"}}></hr>
                        </div>
                        <div className="about-skill">
                        <p>JavaScript & Typescript</p><hr style={{width:"60%"}}></hr>
                        </div>
                        <div className="about-skill">
                        <p>NodeJs & Express</p><hr style={{width:"50%"}}></hr>
                        </div>

                    </div>
                </div>
            </div>
            <div className="about-achievements">
                <div className="about-achievement">
                    <h1>1500+</h1>
                    <p> Rating on CodeForces </p>
                </div>
                <hr/>
                <div className="about-achievement">
                    <h1>04+</h1>
                    <p> projects to complete </p>
                </div>
                <hr/>
                <div className="about-achievement">
                    <h1>500+</h1>
                    <p>LetCode Problems</p>
                </div>
            </div>

        </div>
    )
}

export default About